import { Component } from 'react';
import ReactSelect from '../../components/ReactSelect';
import { withTranslation } from 'react-i18next';

class AddLocation extends Component {
    constructor() {
        super();

        this.onSave = this.onSave.bind(this);
        this.updateCountries = this.updateCountries.bind(this);

        this.state = {
            geo_location: '',
        };
    }

    onSave() {
        fetch(
            `${this.props.current_url}/customers/add-geo-location/?geo_location=${this.state.geo_location}`,
        )
            .then((res) => res.json())
            .then((res) => {
                if (res.reload) {
                    window.location.reload();
                }
            })
            .catch((err) => console.log(err));
    }

    updateCountries(data) {
        this.setState({ geo_location: data.value });
    }

    render() {
        const { t } = this.props;
        const geo_locations = JSON.parse(this.props.geo_locations);
        const optionList = geo_locations.map((item) => ({ value: item.geo, label: item.location }));
        optionList.unshift({ value: '', label: 'None' });

        return (
            <div
                style={{
                    zIndex: '10',
                    position: 'relative',
                    display: 'flex',
                    margin: '15px 0',
                    justifyContent: 'flex-end',
                }}
            >
                <div className="set-location">{t('discover.entity.set_your_location')}</div>
                <ReactSelect
                    options={optionList}
                    onChange={this.updateCountries}
                    placeholder={t('discover.entity.select_location')}
                    isSearchable={true}
                    blurInputOnSelect={true}
                />
                <div style={{ textAlign: 'end' }}>
                    <button
                        className="button button-filled button-primary width-sm"
                        onClick={this.onSave}
                    >
                        {t('discover.entity.save')}
                    </button>
                </div>
            </div>
        );
    }
}

export default withTranslation()(AddLocation);
